import type { ReadonlyVec3 } from "gl-matrix";

import type { AppDispatch } from "app/store";
import type { ObjectDataAccess } from "dataAccess";
import { renderActions } from "features/render";
import { telemetry } from "telemetry";
import { getObjectBoundsW } from "utils/objectData";

/**
 * A section plane is fully determined by the surface pick, so it is placed straight away.
 * The object's extent along the plane normal only widens the standalone slider's range —
 * nothing in the section tool reads it — so it is resolved afterwards instead of holding
 * the click behind a metadata round-trip.
 */
export async function backfillPlaneBounds({
    dispatch,
    dataAccess,
    objectId,
    boundsRequestId,
    normal,
    signal,
}: {
    dispatch: AppDispatch;
    dataAccess: ObjectDataAccess | undefined;
    objectId: number | undefined;
    boundsRequestId: number | undefined;
    normal: ReadonlyVec3;
    signal?: AbortSignal;
}) {
    if (objectId === undefined || boundsRequestId === undefined || !dataAccess) {
        return;
    }

    try {
        const wBounds = await getObjectBoundsW(dataAccess, objectId, normal, signal);
        if (!wBounds) {
            return;
        }

        dispatch(
            renderActions.setClippingPlaneWBounds({
                boundsRequestId,
                wBounds,
            }),
        );
    } catch (error) {
        telemetry.trackCaughtException({
            source: "clippingPlanes.backfillPlaneBounds",
            category: "render",
            error,
        });
    }
}
